// EXTERNAL
import React from "react";
// COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
// CONTEXT
import { useCreativeDispatch, useCreativeState } from "../../../../contexts/creative.context";
// CONFIGS
import studio_config from "../../../../configs/studio.json";
// TYPES
import { StudioConfig } from "../types";

export function ContentDescription() {
  const creative = useCreativeState();
  const creativeDispatch = useCreativeDispatch();
  const studioConfig: StudioConfig = studio_config;
  const frameRatios = studioConfig.formats[creative.metadata.format || "post"].media.frameRatios;
  const matchedFrameRatio = frameRatios.findIndex((frameRatio: FrameRatio) => frameRatio.name === creative.metadata.aspectRatio);
  const maxContentCharLength = studioConfig.formats[creative.metadata.format || "post"].media.frameRatios[matchedFrameRatio].maxContentCharLength;

  return (
    <ComponentLibrary.PCMaxlineTextArea
      header={studioConfig.formats[creative.metadata.format].inputs.content.header}
      subheader={"3 lines max"}
      rows={3}
      placeholder={`${creative.metadata.format[0].toUpperCase() + creative.metadata.format.slice(1)} description`}
      name="post-description"
      text={decodeURI(creative.metadata.content)}
      maxLength={maxContentCharLength || 300}
      changeHandler={(e: React.ChangeEvent<Element>) => {
        const { value } = e.target as HTMLTextAreaElement;
        creativeDispatch({
          type: "UPDATE_CREATIVE_METADATA_CONTENT",
          payload: { content: value },
        });
      }}
    />
  );
}
